export const applicationMixin = {
  computed: {
    ...mapGetters('application', [
      'getAppSize',
      'appIsLarge',
      'appIsSmall',
      'appIsMobile',
      'appIsTablet',
      'appIsExtraLarge',
    ]),
  },
};
